module.exports = __webpack_public_path__ + "static/media/gameboy-w3.1acaaf03.png";